const { styled } = require('@mui/styles')

export const FormWrapper = styled('form')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
}))
